module.exports = __webpack_public_path__ + "static/media/cert_48.729e58f5.jpg";